import "../../../public/showcase/js/polyfills.js";
import "../../../public/showcase/js/runtime.js";
import "../../../public/showcase/js/es2015-polyfills.js";
import "../../../public/showcase/js/main.js";

import Helmet from "react-helmet";
import React from "react";
import ShDetailPage from "./sh-wrappers/sh-detail-page";
import Disclaimers from "./disclaimers";
import { getAgentIds, isStagingSite } from "../shared/util.js";

export default class Listing extends React.Component {
  buildMetaRobotsContent = () => {
    if (isStagingSite()) return "noindex";

    const listingAgentIds = (this.props.listing.agents || []).map(
      (x) => x.agentId
    );
    const entityAgentIds = [].concat(getAgentIds(this.props.entity));
    return listingAgentIds.some((id) => entityAgentIds.indexOf(id) >= 0)
      ? "all"
      : "noindex";
  };

  render() {
    if (this.props.listing) {
      const title = `${
        this.props.listing.fullAddress || this.props.listing.title
      } | Sotheby’s International Realty Inc.`;
      return (
        <React.Fragment>
          <Helmet>
            <title>{title}</title>
            <meta name="robots" content={this.buildMetaRobotsContent()} />
            <meta
              name="description"
              content={`View price, pictures and listing information for ${this.props.listing.fullAddress}. Browse a wide selection of luxury real estate for sale.`}
            />
            <meta property="og:title" content={title} />
            <meta
              property="og:image"
              content={
                this.props.listing.hasImages && this.props.listing.images[0].src
              }
            />
            <meta
              property="og:description"
              content={this.props.listing.ogMetaDescription}
            />
            <link rel="stylesheet" href="/showcase/css/styles.css" />
            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700"
            />
          </Helmet>
          <ShDetailPage
            listing={this.props.listing}
            entity={this.props.entity}
          />
          <Disclaimers
            config={this.props.config}
            listing={this.props.listing}
            showBottomCourtesyInfo={
              this.props.entity.region.showBottomCourtesyInfo
            }
            region={this.props.listing.regionUrlPart}
          />
        </React.Fragment>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/listing-detail/listing.js